import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const UpdateContactInfoSchema = T.Object({
  registration: T.String({ minLength: 1, error: 'Matrícula é obrigatória' }),
  email: T.String({ format: 'email', error: 'Email inválido' }),
  phone: T.String({ minLength: 10, error: 'Telefone deve ter pelo menos 10 dígitos' }),
  // Tenant slug for multi-tenant user lookup (required to avoid cross-tenant conflicts)
  tenantSlug: T.Optional(T.String({ minLength: 1, maxLength: 50 })),
});

export type UpdateContactInfoInputType = typeof UpdateContactInfoSchema.static;

export async function ValidateUpdateContactInfoInput(value: unknown): Promise<UpdateContactInfoInputType> {
  return Value.Parse(UpdateContactInfoSchema, value);
}

export function checkUpdateContactInfoInput(field: string, value: unknown): string | boolean {
  return validateField(UpdateContactInfoSchema, field, value);
}
